import { supabase } from "@/infrastructure/supabase/client";
import type { CandidateChoiceRow } from "@/infrastructure/supabase/database.types";

export interface UpsertCandidateChoiceInput {
  candidate_id: string;
  component_id: string;
  product_id: string | null;
  override_notes_md: string | null;
}

export const candidateChoicesRepository = {
  async list(): Promise<CandidateChoiceRow[]> {
    const { data, error } = await supabase.from("candidate_choices").select("*");
    if (error) throw error;
    return data ?? [];
  },

  async listByCandidate(candidateId: string): Promise<CandidateChoiceRow[]> {
    const { data, error } = await supabase
      .from("candidate_choices")
      .select("*")
      .eq("candidate_id", candidateId);
    if (error) throw error;
    return data ?? [];
  },

  async upsert(input: UpsertCandidateChoiceInput): Promise<CandidateChoiceRow> {
    const { data, error } = await supabase
      .from("candidate_choices")
      .upsert(input, { onConflict: "candidate_id,component_id" })
      .select("*")
      .single();
    if (error) throw error;
    return data;
  },

  async remove(candidateId: string, componentId: string): Promise<void> {
    const { error } = await supabase
      .from("candidate_choices")
      .delete()
      .eq("candidate_id", candidateId)
      .eq("component_id", componentId);
    if (error) throw error;
  },
};
